// @ts-nocheck
import styled from 'styled-components';

export const ReportingStyle = styled.div`
  background-color: #f9f9f9;
  min-height: 100vh;

  .reportingContent {
    width: 100%;
    margin: auto;
    padding: 1.5rem 2rem;
  }

  @media (max-width: 1440px) {
    .reportingContent {
      padding: 1.5rem 0.8rem;
    }
  }

  @media (min-width: 1440px) {
    .reportingContent {
      max-width: 1440px;
    }
  }

  @media (min-width: 1600px) {
    .reportingContent {
      max-width: 1600px;
    }
  }

  @media (min-width: 1920px) {
    .reportingContent {
      max-width: 1920px;
    }
  }
`;
